import { useCommands } from '@remirror/react';
import { useCallback } from 'react';

export function useFocusTextEditor() {
  const commands = useCommands();
  return useCallback(() => commands.focus(), [commands]);
}
